import { render, staticRenderFns } from "./NapasError.vue?vue&type=template&id=14107256&"
import script from "./NapasError.vue?vue&type=script&lang=ts&"
export * from "./NapasError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports